import axios from 'axios'

export default {
  getInvoices ( params, callback ) {
    axios.get('/invoices', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getInvoice ( invoiceId, callback, fallback ) {
    axios.get('/invoices/' + invoiceId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  create ( data, callback, fallback ) {
    axios.post( '/invoices', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( invoiceId, data, callback, fallback ) {
    axios.post( '/invoices/' + invoiceId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  clone ( data, callback, fallback ) {
    axios.post( '/invoices/' + data.id + '/clone', data)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( invoiceId, callback, fallback ) {
    axios.delete( '/invoices/' + invoiceId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getItems ( invoiceId, params, callback ) {
    axios.get('/invoices/' + invoiceId + '/items', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  createItem ( invoiceId, data, callback, fallback ) {
    axios.post( '/invoices/' + invoiceId + '/items', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  saveItem ( invoiceId, itemId, data, callback, fallback ) {
    axios.post( '/invoices/' + invoiceId + '/items/' + itemId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteItem ( invoiceId, itemId, callback, fallback ) {
    axios.delete( '/invoices/' + invoiceId + '/items/' + itemId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  downloadPDF ( invoiceId, callback, fallback ) {
    axios({
      url: '/invoices/' + invoiceId + '/pdf',
      method: 'GET',
      responseType: 'blob', // important
    }).then(resp => {
      callback( resp );
    }).catch(error => {
      fallback(error);
    });
  },
  printWIP ( params, callback, fallback ) {
    axios.get('/invoices/wip', {
      responseType: 'blob', // important
      params
    }).then(resp => {
      callback( resp );
    }).catch(error => {
      fallback(error);
    });
  },
  getQuoteItems ( invoiceId, params, callback, fallback ) {
    axios.get('/invoices/' + invoiceId + '/quote-items', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getOrderItems ( invoiceId, params, callback, fallback ) {
    axios.get('/invoices/' + invoiceId + '/order-items', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getTasks ( invoiceId, params, callback, fallback ) {
    axios.get('/invoices/' + invoiceId + '/tasks', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getTimesheet ( invoiceId, params, callback, fallback ) {
    axios.get('/invoices/' + invoiceId + '/timesheet', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  moveItemToInvoice ( invoiceId, data, callback, fallback ) {
    axios.post( '/invoices/' + invoiceId + '/move-item', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  }
}
